module.exports = __webpack_public_path__ + "static/media/review-logo.62f12c09.svg";